export const userTypeConfig = {
  1: { listName: 'person' },
  2: { listName: 'department' },
  3: { listName: 'role' }
};
export const conditionType = [
  { name: '等于', value: 1 },
  { name: '不等于', value: 2 },
  { name: '包含', value: 3 },
  { name: '不包含', value: 4 },
  { name: '属于', value: 5 },
  { name: '不属于', value: 6 },
  { name: '从属', value: 7 },
  // { name: '不从属下级包含', value: 8 },
  // { name: '下级不包含', value: 9 },
  { name: '大于', value: 10 },
  { name: '大于等于', value: 11 },
  { name: '小于', value: 12 },
  { name: '小于等于', value: 13 }
];
// 条件下拉框配置
export const conditionTypeConfig = {
  // 发起人的下拉框
  promoter: [
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
    // { name: '属于', value: 'in' },
    // { name: '不属于', value: 'in' },
    // { name: '从属', value: 'notIn' }
  ],
  // input 下拉框
  input: [
    { name: '包含', value: 'strContains' },
    { name: '不包含', value: 'notStrContains' }
  ],
  textarea: [
    { name: '包含', value: 'strContains' },
    { name: '不包含', value: 'notStrContains' }
  ],
  number: [
    { name: '等于', value: '==' },
    { name: '不等于', value: '!=' },
    { name: '大于', value: '>' },
    { name: '大于等于', value: '>=' },
    { name: '小于', value: '<' },
    { name: '小于等于', value: '<=' }
  ],
  // select 下拉框
  select: [
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
  ],
  // checkBox
  checkbox: [
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
  ],
  radio: [
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
  ],
  time: [
    { name: '等于', value: '==' },
    { name: '不等于', value: '!=' },
    { name: '大于', value: '>' },
    { name: '大于等于', value: '>=' },
    { name: '小于', value: '<' },
    { name: '小于等于', value: '<=' }
  ],
  date: [
    { name: '等于', value: '==' },
    { name: '不等于', value: '!=' },
    { name: '大于', value: '>' },
    { name: '大于等于', value: '>=' },
    { name: '小于', value: '<' },
    { name: '小于等于', value: '<=' }
  ],
  switch: [
    { name: '等于', value: '==' },
    { name: '不等于', value: '!=' },
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
  ],
  '': [
    { name: '等于', value: '==' },
    { name: '不等于', value: '!=' },
    { name: '大于', value: '>' },
    { name: '大于等于', value: '>=' },
    { name: '小于', value: '<' },
    { name: '小于等于', value: '<=' },
    { name: '包含', value: 'in' },
    { name: '不包含', value: 'notIn' }
  ]
};
export const defaultTypeSelect = [
  // 可以选择发起人，现在先干掉
  // {
  //   type: 'promoter',
  //   id: 'promoter',
  //   label: '发起人'
  // }
];
